import { SaveType } from "@/js/value-objects/save-type";
import { nullToEmpty } from "@/js/utils";
import { LoginId } from "@/js/value-objects/login-id";

export class UserTranslator {
  static toPayload(editedItem, saveType) {
    if (!(saveType instanceof SaveType)) {
      throw new Error(`引数不正 [saveType=${saveType}]`);
    }
    if (saveType.isDelete()) {
      return {
        user_id: editedItem.user_id,
        delete_flg: "1",
        hash: editedItem.hash
      };
    }
    if (saveType.isCreate()) {
      return {
        user_id: `${LoginId.factory(
          editedItem.municip_code,
          editedItem.login_id_suffix
        ).toUserId()}`,
        user_name: editedItem.user_name,
        organize_id: editedItem.organize_id,
        ope_auth_gp_id: nullToEmpty(editedItem.ope_auth_gp_id),
        password: editedItem.password
      };
    }
    if (saveType.isUpdate()) {
      return {
        user_id: editedItem.user_id,
        user_name: editedItem.user_name,
        ope_auth_gp_id: nullToEmpty(editedItem.ope_auth_gp_id),
        hash: editedItem.hash,
        password_resetting_flg: editedItem.isUpdatePassword,
        password: editedItem.password
      };
    }
  }
}
